import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c3d7170")

_pushScopeId("data-v-1c3d7170")
const _hoisted_1 = { class: "container agencies-page" }
const _hoisted_2 = { class: "main-reverse-page-title" }
const _hoisted_3 = { class: "d-lg-flex" }
const _hoisted_4 = { class: "agencies-actions order-lg-1 col mb-lg-0 justify-content-center justify-content-lg-end" }
const _hoisted_5 = { class: "agencies-search col-lg-3 mt-auto" }
const _hoisted_6 = { class: "agencies-total-filter mt-auto px-lg-2" }
const _hoisted_7 = { class: "agencies-total order-lg-1" }
const _hoisted_8 = { class: "show-all-clear-filter align-items-lg-center" }
const _hoisted_9 = { class: "agencies-filter-bar mt-auto px-lg-2" }
const _hoisted_10 = { class: "filter-item" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "filter-item" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "filter-item" }
const _hoisted_15 = { class: "label" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", { class: "search-button-wrapper pl-15 d-flex align-items-end" }, [
  /*#__PURE__*/_createVNode("button", { type: "submit" }, [
    /*#__PURE__*/_createVNode("i", { class: "icon-f icon-search fs-20" })
  ])
], -1)
const _hoisted_17 = {
  key: 0,
  class: "mobile-grid"
}
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_19 = {
  key: 0,
  class: "status-green"
}
const _hoisted_20 = {
  key: 1,
  class: "status-red"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "line" }, null, -1)
const _hoisted_22 = { class: "mobile-table-info-card" }
const _hoisted_23 = { class: "details-row" }
const _hoisted_24 = { class: "details-row" }
const _hoisted_25 = {
  key: 0,
  class: "m-0"
}
const _hoisted_26 = { class: "details-row" }
const _hoisted_27 = {
  key: 0,
  class: "m-0"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-20" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "desktop-grid"
}
const _hoisted_30 = { class: "w100" }
const _hoisted_31 = { style: {"width":"22%"} }
const _hoisted_32 = { style: {"width":"23%"} }
const _hoisted_33 = { style: {"width":"10%"} }
const _hoisted_34 = { class: "desktop-table-action" }
const _hoisted_35 = { class: "thead-cell-center" }
const _hoisted_36 = { class: "desktop-table-text-setting" }
const _hoisted_37 = { class: "desktop-table-text-setting" }
const _hoisted_38 = {
  key: 0,
  class: "cuted-cell m-0"
}
const _hoisted_39 = { class: "desktop-table-text-setting" }
const _hoisted_40 = {
  key: 0,
  class: "m-0"
}
const _hoisted_41 = { class: "desktop-table-text-setting" }
const _hoisted_42 = { class: "desktop-table-text-setting" }
const _hoisted_43 = {
  key: 0,
  class: "status-green"
}
const _hoisted_44 = {
  key: 1,
  class: "status-red"
}
const _hoisted_45 = { class: "desktop-table-action text-center" }
const _hoisted_46 = /*#__PURE__*/_createVNode("i", { class: "icon-f icon-pencil-edit fs-16" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Calendar = _resolveComponent("Calendar")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('navbar.indexAgencies')), 1),
    _createVNode("form", {
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.search()), ["prevent"]))
    }, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: { name: 'agency-new' },
            class: "agency-circle-btn btn-green flex-center"
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('button.newAgency')), 1)
            ]),
            _: 1
          })
        ]),
        _createVNode("div", _hoisted_5, [
          _withDirectives(_createVNode("input", {
            class: "bookit-input w100",
            type: "text",
            placeholder: _ctx.$t('agencies.searchPlaceholder'),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filter.name = $event))
          }, null, 8, ["placeholder"]), [
            [
              _vModelText,
              _ctx.filter.name,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("div", null, _toDisplayString(_ctx.$t('agencies.totalFiltered')) + ":", 1),
            _createVNode("div", null, _toDisplayString(_ctx.totalFiltered) + " (" + _toDisplayString(_ctx.$t('agencies.ofAgencies')) + " " + _toDisplayString(_ctx.total) + ")", 1)
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode("span", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.showAll && _ctx.showAll(...args)))
            }, _toDisplayString(_ctx.$t('button.showAll')), 1)
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode("div", _hoisted_10, [
            _createVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('agencies.filter.email')), 1),
            _withDirectives(_createVNode("input", {
              class: "bookit-input w100",
              type: "text",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filter.email = $event))
            }, null, 512), [
              [
                _vModelText,
                _ctx.filter.email,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('agencies.filter.mobile')), 1),
            _withDirectives(_createVNode("input", {
              class: "bookit-input w100",
              maxlength: "16",
              type: "text",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.filter.mobile = $event)),
              onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.additionalValidation && _ctx.additionalValidation(...args))),
              onKeypress: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isTelephone($event)))
            }, null, 544), [
              [
                _vModelText,
                _ctx.filter.mobile,
                void 0,
                { trim: true }
              ]
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('agencies.filter.createDate')), 1),
            _createVNode(_component_Calendar, {
              onInput: _ctx.trimDate,
              modelValue: _ctx.filter.createDate,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filter.createDate = $event)),
              selectionMode: "single",
              dateFormat: "dd/mm/yy"
            }, null, 8, ["onInput", "modelValue"])
          ]),
          _hoisted_16
        ])
      ])
    ], 32),
    (_ctx.isMobileView && _ctx.rows.length > 0)
      ? (_openBlock(), _createBlock("div", _hoisted_17, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "agency-item",
              key: index
            }, [
              _createVNode(_component_router_link, {
                to: { name: 'agency-view', params: { id: row.id } },
                class: "header-line"
              }, {
                default: _withId(() => [
                  _createVNode("span", null, _toDisplayString(row.id), 1),
                  _hoisted_18,
                  _createVNode("span", null, [
                    (row.isActive)
                      ? (_openBlock(), _createBlock("span", _hoisted_19, "ACTIVE"))
                      : (_openBlock(), _createBlock("span", _hoisted_20, "NOT ACTIVE"))
                  ])
                ]),
                _: 2
              }, 1032, ["to"]),
              _hoisted_21,
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.name')) + ": ", 1),
                  _createVNode("span", null, _toDisplayString(row.name), 1)
                ]),
                _createVNode("div", _hoisted_24, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.email')) + ": ", 1),
                  (row.email)
                    ? (_openBlock(), _createBlock("span", _hoisted_25, _toDisplayString(row.email), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.mobile')) + ": ", 1),
                  (row.mobile)
                    ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(row.mobile), 1))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_router_link, {
                  to: { name: 'agency-view', params: { id: row.id } },
                  class: "btn-edit"
                }, {
                  default: _withId(() => [
                    _hoisted_28
                  ]),
                  _: 2
                }, 1032, ["to"])
              ])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isMobileView)
      ? (_openBlock(), _createBlock("div", _hoisted_29, [
          _createVNode("table", _hoisted_30, [
            _createVNode("thead", null, [
              _createVNode("tr", null, [
                _createVNode("td", {
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.sortBy('Name'))),
                  style: {"width":"25%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('agencies.name')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Name')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", _hoisted_31, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.email')), 1)
                ]),
                _createVNode("td", _hoisted_32, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.mobile')), 1)
                ]),
                _createVNode("td", {
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.sortBy('Date'))),
                  style: {"width":"15%"}
                }, [
                  _createVNode("span", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('agencies.createDate')) + " ", 1),
                    _createVNode("i", {
                      class: ["icon-f icon-sort-arrows fs-12 sort-arrow-icon", _ctx.getArrowClass('Date')]
                    }, null, 2)
                  ])
                ]),
                _createVNode("td", _hoisted_33, [
                  _createVNode("span", null, _toDisplayString(_ctx.$t('agencies.isActive')), 1)
                ]),
                _createVNode("td", _hoisted_34, [
                  _createVNode("span", _hoisted_35, _toDisplayString(_ctx.$t('agencies.actions')), 1)
                ])
              ])
            ]),
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", _hoisted_36, [
                    _createVNode(_component_router_link, {
                      to: { name: 'agency-view', params: { id: row.id } },
                      class: "text-link cuted-cell m-0"
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(row.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createVNode("td", _hoisted_37, [
                    (row.email)
                      ? (_openBlock(), _createBlock("span", _hoisted_38, _toDisplayString(row.email), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_39, [
                    (row.mobile)
                      ? (_openBlock(), _createBlock("span", _hoisted_40, _toDisplayString(row.mobile), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("td", _hoisted_41, _toDisplayString(_ctx.formatLocalDate(row.createDate)), 1),
                  _createVNode("td", _hoisted_42, [
                    (row.isActive)
                      ? (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(_ctx.$t('label.active')), 1))
                      : (_openBlock(), _createBlock("span", _hoisted_44, _toDisplayString(_ctx.$t('label.notactive')), 1))
                  ]),
                  _createVNode("td", _hoisted_45, [
                    _createVNode(_component_router_link, {
                      to: { name: 'agency-view', params: { id: row.id } },
                      class: "m-0"
                    }, {
                      default: _withId(() => [
                        _hoisted_46
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ])
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})